import React from 'react';
import { Plus, X, GripVertical } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const ChallengesSection = ({
  challengeTypes,
  setChallengeTypes,
  updateChallengeType,
  removeChallengeType,
  addChallengeType,
}) => {
  return (
    <Card className="rounded-xl border-slate-200 shadow-sm">
      <CardContent className="p-6 space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-medium">Challenge Types</h3>
            <p className="text-sm text-slate-500">Add different account sizes and challenge options</p>
          </div>
          <Button onClick={addChallengeType}>
            <Plus className="h-4 w-4 mr-2" />
            Add Challenge
          </Button>
        </div>

        {challengeTypes.map((challenge, index) => (
          <Card key={challenge.id} className="border-slate-200">
            <CardContent className="p-4 space-y-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <GripVertical className="h-5 w-5 text-slate-400" />
                  <span className="font-medium">Challenge {index + 1}</span>
                </div>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => removeChallengeType(challenge.id)}
                  className="text-red-600"
                >
                  <X className="h-4 w-4" />
                </Button>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label>Name</Label>
                  <Input
                    placeholder="2-Step $10k Account"
                    value={challenge.name}
                    onChange={(e) => updateChallengeType(challenge.id, 'name', e.target.value)}
                    className="mt-2"
                  />
                </div>
                <div>
                  <Label>Price (USD)</Label>
                  <Input
                    type="number"
                    placeholder="99"
                    value={challenge.price}
                    onChange={(e) => updateChallengeType(challenge.id, 'price', e.target.value)}
                    className="mt-2"
                  />
                </div>
                <div>
                  <Label>Max Funding</Label>
                  <Input
                    type="number"
                    placeholder="10000"
                    value={challenge.maxFunding}
                    onChange={(e) => updateChallengeType(challenge.id, 'maxFunding', e.target.value)}
                    className="mt-2"
                  />
                </div>
                <div>
                  <Label>Profit Split (%)</Label>
                  <Input
                    type="number"
                    placeholder="80"
                    value={challenge.profitSplit}
                    onChange={(e) => updateChallengeType(challenge.id, 'profitSplit', e.target.value)}
                    className="mt-2"
                  />
                </div>
                <div>
                  <Label>Profit Target (%)</Label>
                  <Input
                    placeholder="8% Phase 1 / 5% Phase 2"
                    value={challenge.profitTarget}
                    onChange={(e) => updateChallengeType(challenge.id, 'profitTarget', e.target.value)}
                    className="mt-2"
                  />
                </div>
                <div>
                  <Label>Payout Cycle</Label>
                  <Select
                    value={challenge.payoutCycle}
                    onValueChange={(val) => updateChallengeType(challenge.id, 'payoutCycle', val)}
                  >
                    <SelectTrigger className="mt-2">
                      <SelectValue placeholder="Select" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="1D">1 Day</SelectItem>
                      <SelectItem value="2D">2 Days</SelectItem>
                      <SelectItem value="14D">14 Days</SelectItem>
                      <SelectItem value="custom">Custom</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Frequency</Label>
                  <Select
                    value={challenge.frequency}
                    onValueChange={(val) => updateChallengeType(challenge.id, 'frequency', val)}
                  >
                    <SelectTrigger className="mt-2">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="Always Available">Always Available</SelectItem>
                      <SelectItem value="Monthly">Monthly</SelectItem>
                      <SelectItem value="Limited-Time">Limited-Time</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Affiliate Link (Override)</Label>
                  <Input
                    type="url"
                    placeholder="https://..."
                    value={challenge.affiliateLink}
                    onChange={(e) => updateChallengeType(challenge.id, 'affiliateLink', e.target.value)}
                    className="mt-2"
                  />
                </div>
              </div>
            </CardContent>
          </Card>
        ))}

        {challengeTypes.length === 0 && (
          <div className="text-center py-8 text-slate-500">
            No challenge types added yet
          </div>
        )}
      </CardContent>
    </Card>
  );
};
